<template>
  <div :is="menuFixed ? 'm-custom-scrollbar': 'div' " :class="{'menu_fixed': menuFixed}" class="col-md-3 left_col">
    <div class="left_col scroll-view">
      <div class="navbar nav_title" style="border: 0;">
        <a class="site_title" href="/">
          <!--          <i class="fab fa-cuttlefish"></i>&nbsp;-->
          <img alt="" src="/favicon.png">
          <span>{{ title || 'Fulfillment CMS' }}</span>
        </a>
      </div>

      <div class="clearfix"></div>

      <!-- menu profile quick info -->
      <div class="profile clearfix img_2">
        <div class="profile_pic">
          <img :src="avatarPath || '/images/user.png'" alt="..." class="img-circle profile_img">
        </div>
        <div class="profile_info">
          <span>Welcome,</span>
          <h2>{{ userFullName }}</h2>
        </div>
        <div class="clearfix"></div>
      </div>
      <!-- /menu profile quick info -->

      <br/>

      <!-- sidebar menu -->
      <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
        <menu-section v-for="menuSection in menuData"
                      :label="menuSection.label"
                      :menu-items="menuSection.menuItems"
                      :key="menuSection.label"
        />
      </div>
      <!-- /sidebar menu -->

      <!-- /menu footer buttons -->
      <div class="sidebar-footer hidden-small">
        <a data-placement="top" data-toggle="tooltip" title="Settings">
          <span aria-hidden="true" class="glyphicon glyphicon-cog"></span>
        </a>
        <a v-b-tooltip.hover title="FullScreen" @click="isFullscreen = !isFullscreen">
          <i v-if="!isFullscreen" class="fas fa-expand"/>
          <i v-if="isFullscreen" class="fas fa-compress"/>
        </a>
        <a data-placement="top" data-toggle="tooltip" title="Lock">
          <span aria-hidden="true" class="glyphicon glyphicon-eye-close"></span>
        </a>
        <router-link v-b-tooltip.hover.top tag="a" title="Đăng xuất" to="/sign-out">
          <span aria-hidden="true" class="glyphicon glyphicon-off"></span>
        </router-link>
      </div>
      <!-- /menu footer buttons -->
    </div>
  </div>
</template>

<script>
import MenuSection from "@/components/layout/SideBar/MenuSection";
import SidebarMenu from "@/components/layout/SideBar/SidebarMenu";
import SidebarMenuItem from "@/components/layout/SideBar/SidebarMenuItem";

export default {
  name: "LeftSideBar",
  components: {SidebarMenuItem, SidebarMenu, MenuSection},
  props: {
    title: String,
    avatarPath: String,
    userFullName: String,
    menuFixed: Boolean,
    menuData: Array,
  },
  data() {
    return {
      isFullscreen: false,
    }
  },
  mounted() {
  },
  methods: {
    openFullscreen() {
      let elem = document.getElementsByTagName('body')[0];
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
    }
  },
  watch: {
    isFullscreen(newValue, oldValue) {
      if (newValue) {
        this.openFullscreen();
      } else {
        this.closeFullscreen();
      }
    }
  }
}
</script>

<style scoped>

</style>